import { resolveBusinessIdentityId } from './identityRegistry';

/**
 * Display the server's effective `sector_<slug>` entitlement decision.
 * Some routes use underscores instead of hyphens - check both.
 */

export function normaliseSectorId(id: string): string {
  const normalized = id.toLowerCase().trim().replace(/_/g, '-').replace(/\s+/g, '-');
  return resolveBusinessIdentityId(normalized) ?? normalized;
}

/** Possible entitlement feature strings for a sector landing/dashboard */
export function sectorEntitlementKeys(sectorId: string): string[] {
  const n = normaliseSectorId(sectorId);
  return [`sector_${n}`, `sector_${n.replace(/-/g, '_')}`];
}

export function hasSectorEntitlement(
  sectorId: string,
  entitlements: string[],
  _opts?: { userSector?: string | null; orgSector?: string | null }
): boolean {
  const keys = new Set(sectorEntitlementKeys(sectorId));
  // Profile fields describe the account; they are not proof of a paid business plan.
  return entitlements.some((entitlement) => keys.has(entitlement));
}

/** Derive sector slugs from entitlement list for localStorage cache (server is source of truth). */
export function sectorsFromEntitlements(entitlements: string[]): string[] {
  const sectors = new Set<string>();
  for (const entitlement of entitlements) {
    if (!entitlement.startsWith('sector_')) continue;
    sectors.add(normaliseSectorId(entitlement.slice('sector_'.length)));
  }
  return [...sectors];
}
